<template>
	<div>
		<Form ref="formInline" :model="formInline" inline style="text-align: left;margin-top: 1%;">
			<!-- 			<FormItem prop="trackName">
				<Input type="text" v-model="formInline.deviceNum" placeholder="设备编号/IMEI/MAC" >
					  <span slot="prepend">充电站</span>
					</Input>
			</FormItem> -->
			<FormItem prop="trackName" label="充电站:" :label-width="100">
				<Select filterable placeholder="站点列表" style="width: 200px;" v-model="formInline.StationId">
					<Option :value=0>全部</Option>
					<Option v-bind:key="item.StationId" v-for="(item) in StationList" :value="item.StationId">{{item.StationName}}</Option>
				</Select>
			</FormItem>
			<FormItem>
				<Button type="primary" @click="handleSubmit('formInline')" v-if="hasWidgets('search')">查询</Button>
			</FormItem>
		</Form>
		<Table :row-class-name="rowClassName" :columns="columns1" :data="data1" :height="tableHeight"></Table>
		<MyPage ref="sonPage" :param="pageParam" :url="getAlarmingInfoUrl" @listData='getDeviceData'></MyPage>
	</div>
</template>

<script>
	import dateFormat from '../../../../public/js/comm.js'
	import Qs from 'qs'
	import expandRow from './ChargingInfoExpand.vue';
	import {
		mapState,
		mapGetters,
		mapActions
	} from 'vuex'
	import webapi from '../../../webapi.js';
	export default {
		data() {
			return {
				getAlarmingInfoUrl: webapi.base_api_url + '/Operations/GetAlarmingInfo',
				loadingStatus: false,
				//model表单
				params: "", //table 传参
				tableHeight: "650",
				modal: {
					Title: "设备信息添加",
					type: "addDevice"
				},
				BreadcrumbList: ['充电监控', '>>', '实时告警'],
				formInline: {
					StationId: 0
				},
				//table标题数据
				columns1: [{
						title: '设备编号',
						key: 'EquipmentNo',
						minWidth: 120,
					}, {
						title: '设备名称',
						key: 'EquipmentName',
						minWidth: 120,
					},
					{
						title: '枪编号',
						key: 'ConnectorNo',
						minWidth: 120,
					},
					{
						title: '枪名称',
						key: 'ConnectorName',
						minWidth: 120,
					},
					{
						title: '设备类型',
						key: 'EquipmentType',
						minWidth: 120,
						render: (h, params) => {
							return h('div',
								params.row.EquipmentTypeDesc
							);
						}
					},
					{
						title: '枪类型',
						key: 'ConnectorType',
						minWidth: 120,
						render: (h, params) => {
							return h('div',
								params.row.ConnectorTypeDesc
							);
						}
					},
					{
						title: '工作状态',
						key: 'WorkStatus',
						minWidth: 100,
						render: (h, params) => {
							return h('div',
								params.row.WorkStatusDesc
							);
						}
					},
					{
						title: '告警',
						key: 'AlarmCode',
						minWidth: 120,
						render: (h, params) => {
							let type = ''
							let color = ''
							switch (params.row.AlarmCode) {
								case 0:
									color = "success",
										type = "无告警"
									break;
								default:
									color = "error",
										type = params.row.AlarmDesc
									break;
							}
							return h('Tag', {
									props: {
										color: color
									}
								},
								type
							);
						}
					},
					// {
					// 	title: '最高告警',
					// 	key: 'MaxAlarmCode',
					// 	width:150,
					// 	render: (h, params) => {
					// 		let type = ''
					// 		let color = ''
					// 		switch (params.row.MaxAlarmCode) {
					// 			case 0:
					// 				color = "success",
					// 					type = "无告警"
					// 				break;
					// 			default:
					// 				color = "error",
					// 					type = params.row.MaxAlarmDesc
					// 				break;
					// 		}
					// 		return h('Tag', {
					// 				props: {
					// 					color: color
					// 				}
					// 			},
					// 			type
					// 		);
					// 	}
					// },
					{
						title: '连接状态',
						key: 'CarCoupleStatus',
						minWidth: 100,
						render: (h, params) => {
							let type = ''
							let color = ''
							switch (params.row.CarCoupleStatus) {
								case 0:
									color = "error",
										type = "未连接"
									break;
								default:
									color = "success",
										type = "已连接"
									break;
							}
							// return h('Tag', {
							// 		props: {
							// 			color: color
							// 		}
							// 	},
							// 	type
							// );
							return h('div', type);
						}
					},
					{
						title: '额定功率(KW)',
						key: 'RatedPower',
						minWidth: 100,
						render: (h, params) => {
							return h('div', params.row.RatedPower)
						}
					}, {
						title: '生产厂家',
						key: 'ManufacturerName',
						minWidth: 120,
						tooltip: true,
					},
					{
						title: '站点名称',
						key: 'StationName',
						minWidth: 120,
						tooltip: true,
					},
					// {
					// 	title: '操作',
					// 	key: 'action',
					// 	width: 200,
					// 	align: 'center',
					// 	render: (h, params) => {
					// 		return h('div', [
					// 			h('Button', {
					// 				props: {
					// 					type: 'primary',
					// 					size: 'small'
					// 				},
					// 				style: {
					// 					marginRight: '5px'
					// 				},
					// 				on: {
					// 					click: () => {
					// 						this.show("stopCharging", params.row.id)
					// 					}
					// 				}
					// 			}, '停止充电')
					// 		]);
					// 	}
					// }
				],
				data1: [],
				timer: ''
			}
		},
		created() {
			const _this = this;
			_this.tableHeight = window.innerHeight - 220;
			window.addEventListener('resize', this.getTableHeight)
		},
		updated() {
		},
		activated() {
			this.timer = setInterval(this.handleSubmit, 30000);
		},
		deactivated() {
			if (this.timer) {
				clearInterval(this.timer); // 在Vue实例销毁前，清除我们的定时器
			}
		},
		destroyed() {
			window.removeEventListener("resize", this.getTableHeight);
		},
		mounted() {
			const _this = this
			_this.handleSubmit();
		},
		beforeDestroy() {},
		computed: {
			pageParam: function() {
				const _this = this;
				const param = _this.formInline;
				return param
			},
			//直接选属性
			...mapState({
				StationList: 'Stations'
			})
		},
		methods: {
			rowClassName: function(row, index) {
				if (index % 2 == 0) {
					return 'demo-table-info-row';
				} else if (index % 2 == 1) {
					return 'demo-table-error-row';
				}
				return '';
			},
			hasWidgets: function(widgetName) {
				return this.$route.meta.widgets.find(w => w.Name == widgetName);
			},
			//操作
			show: function(type, params) {
			},
			getDeviceData: function(data) {
				console.log(data)
				this.data1 = data.Data.List
			},
			handleSubmit: function() {
				if (!this.hasWidgets('search')) return;
				this.$refs.sonPage.getList();
				// 	const _this = this;
				// 	let parms = {
				// 		id: "params"
				// 	}
				// 	_this.$axios.post(webapi.base_api_url + "/Operations/GetAlarmingInfo", parms, {
				// 	}).then(res => {
				// 		console.log("res")
				// 		console.log(res.data)
				// 		if (res.data.Code == 0) {
				// 			_this.data1 = res.data.Data.AlarmingInfos;
				// 		}
				// 	})
			},
			getTableHeight: function() {
				this.tableHeight = window.innerHeight - 220;
			}
		},
	}
</script>

<style>
	/* 	#tree{
		width: 1200px;
		height: 600px;
		margin-top: 7%;
		border: 2px solid red;
	} */

	.ivu-tag-dot {
		border: 0px solid #e8eaec !important;
	}
</style>
